'use strict';

exports.__esModule = true;
exports.usePrevious = undefined;

var _react = require('react');

var usePrevious = exports.usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}; /* eslint-disable import/prefer-default-export */